import CryptoJS from 'crypto-js';

const generateRandomVariableName = () => {
  const chars = 'abcdefghiklmnopqrstvxyzABCDEFGHIKLMNOPQRSTVXYZ_0123456789';
  const firstChars = 'abcdefghiklmnopqrstvxyzABCDEFGHIKLMNOPQRSTVXYZ_';
  
  const length = Math.floor(Math.random() * 4) + 6;
  let result = firstChars.charAt(Math.floor(Math.random() * firstChars.length));
  
  for (let i = 1; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  
  return result;
};

const generateRandomKey = () => {
  const array = new Uint8Array(16);
  window.crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

export const encryptCode = (plaintext, template) => {
  try {
    const keyHex = generateRandomKey();
    const var1 = generateRandomVariableName();
    const var2 = generateRandomVariableName();
    const var3 = generateRandomVariableName();
    
    const key = CryptoJS.enc.Hex.parse(keyHex);
    const keyBase64 = CryptoJS.enc.Base64.stringify(key);
    
    const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    
    const encryptedBase64 = encrypted.toString();
    
    return template
      .replace(/%1/g, var1)
      .replace(/%2/g, var2)
      .replace(/%3/g, var3)
      .replace(/%4/g, keyBase64)
      .replace(/%5/g, encryptedBase64);
  } catch (error) {
    console.error("Encryption error:", error);
    throw new Error("Failed to encrypt code. Please check your input.");
  }
};